import { render } from "./CompanyList.vue?vue&type=template&id=3fe59751&ts=true"
import script from "./CompanyList.vue?vue&type=script&lang=ts"
export * from "./CompanyList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__